import { useContent } from "contexts/contentContext/contentContext.js";
import { useEffect } from "react";
import {
  updateDynamicStatistic,
  updateJumboFormExternalWebsite,
} from "./Helpers/EmbedApiCalls.js";
import config from "config";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import { getPrevCookiesValues } from "./Helpers/ValidationFunctions.js";
import { exampleFieldsJson } from "./Helpers/JsonLists.js";
import {
  defaultFormImages,
  embedColorCode,
} from "../JUMBOform/ExternalJsonsList/JsonLists.js";
import getAsyncImage from "utils/getAsyncImage.js";
import { DOMAIN_NAME } from "utils/globalConsts.ts";

const EmbedFormTemplateSettings = ({
  children,
  formDetails,
  setLoading,
  formInEmbedPage,
  setErrorFields,
  setPrevCookies,
  setStartUpload,
  setEmbedJson,
  setActiveForm,
  displayPreview,
  setFormTitle,
  setFormDescription,
  embedPageFormImage,
  setFormImage,
  setEmbedHideImage,
  setEmbedHideTitle,
  setEmbedHideDescription,
  setButtonBackgroundColor,
  embedPageBrandingColor,
  setButtonTextColor,
  brandingColor,
  setBackgroundFormColor,
  setWidth,
  setHeight,
  setDirection,
  setDisplayFooterLinks,
  hideFooter,
  footerDetails,
  displayFooterLinks,
  setLinkFooters,
  counted,
  setCounted,
  setAllowUseForm,
  setAllowUseFormText,
  isDemoEmbedPage,
  typeUser,
  activeFormInJumboFormsPage,
  setMaxFormHeight,
  setInnerScrollHeight,
  skipFormParam,
  isPickerForm,
}) => {
  const { getCookie } = useCookie();
  const { getTextByKey, getPath, getDirection } = useContent();
  //Set the form details
  useEffect(() => {
    if (formDetails) {
      setLoading(true);
      let allowToUseForm = true;
      let allowToUseFormText = "";
      let activeForm = true;
      if (!activeFormInJumboFormsPage && formInEmbedPage) {
        allowToUseForm = false;
        allowToUseFormText = "embed-exipred-text";
      }

      if (typeUser !== "premium") {
        if (!formInEmbedPage && !formDetails.Embed_Dynamic_Active_User_subs) {
          allowToUseForm = false;
          allowToUseFormText = "embed-form-only-on-page";
        }
      }

      if (typeUser !== "premium" && typeUser !== "business") {
        if (formDetails.Embed_Dynamic_Submissions_Per_Month) {
          if (formDetails.Embed_Dynamic_Submissions_Per_Month >= 50) {
            allowToUseForm = false;
            allowToUseFormText = "embed-trial-limit-mails";
          }
        }
      }
      let prevCookie = "Lead-";
      if (config.api.src.includes("testapi")) {
        prevCookie = "Test-Lead-";
      }
      prevCookie += formDetails.Embed_Dynamic_Id;
      let cookiesForm = getCookie(prevCookie);
      if (cookiesForm !== undefined) {
        setPrevCookies(getPrevCookiesValues(cookiesForm));
      }

      let tempJson = JSON.parse(
        isDemoEmbedPage ? exampleFieldsJson : formDetails.Embed_Dynamic_Body
      );
      setErrorFields([]);
      setStartUpload(false);
      setEmbedJson(tempJson.items);
      if (displayPreview) {
        allowToUseForm = true;
        allowToUseFormText = "";
      } else {
        activeForm = formDetails.Embed_Dynamic_Live_Status;
      }
      const defaultTitle = getTextByKey("default-title");
      const defaultDescription = getTextByKey("default-description");
      setFormTitle(
        isDemoEmbedPage ? defaultTitle : formDetails.Embed_Dynamic_Inner_Title
      );
      setFormDescription(
        isDemoEmbedPage
          ? defaultDescription
          : formDetails.Embed_Dynamic_Description
      );
      if (embedPageFormImage) {
        setFormImage(embedPageFormImage);
      } else {
        if (
          formDetails.Embed_Dynamic_Image &&
          formDetails.Embed_Dynamic_Image.EmbedDynamicFormImageLogicalPath
        ) {
          if (formDetails.Embed_Dynamic_Image_Url) {
            setFormImage(formDetails.Embed_Dynamic_Image_Url);
          }
        } else {
          if (formDetails.Embed_Dynamic_Image_Url) {
            if (
              !formDetails.Embed_Dynamic_Image_Url.includes(
                `${config.api.resource}/assets/images/picker/picker-app.png`
              )
            ) {
              getAsyncImage(
                `images/personal/form-images/webp/${formDetails.Embed_Dynamic_Image_Url}.webp`,
                setFormImage
              );
            } else {
              setFormImage(formDetails.Embed_Dynamic_Image_Url);
            }
          } else {
            let randNum = Math.floor(Math.random() * 18);
            getAsyncImage(
              `images/${defaultFormImages[randNum]}.webp`,
              setFormImage
            );
          }
        }
      }

      setEmbedHideImage(
        formDetails.Embed_Dynamic_Hide_Image !== null
          ? !formDetails.Embed_Dynamic_Hide_Image
          : false
      );
      setEmbedHideTitle(
        formDetails.Embed_Dynamic_Hide_Title !== null
          ? !formDetails.Embed_Dynamic_Hide_Title
          : false
      );
      setEmbedHideDescription(
        formDetails.Embed_Dynamic_Hide_Description !== null
          ? !formDetails.Embed_Dynamic_Hide_Description
          : false
      );
      setButtonBackgroundColor(
        embedPageBrandingColor
          ? embedPageBrandingColor
          : formDetails.Embed_Dynamic_Buttons_Color_Code
          ? formDetails.Embed_Dynamic_Buttons_Color_Code.includes("#")
            ? formDetails.Embed_Dynamic_Buttons_Color_Code
            : "#" + formDetails.Embed_Dynamic_Buttons_Color_Code
          : embedColorCode
      );
      setButtonTextColor(
        brandingColor
          ? "#fff"
          : formDetails.Embed_Dynamic_Button_Text_Color_Code &&
            formDetails.Embed_Dynamic_Button_Text_Color_Code.includes("#")
          ? formDetails.Embed_Dynamic_Button_Text_Color_Code
          : formDetails.Embed_Dynamic_Button_Text_Color_Code &&
            "#" + formDetails.Embed_Dynamic_Button_Text_Color_Code
      );
      setBackgroundFormColor(
        formInEmbedPage
          ? "#fff"
          : formDetails.Embed_Dynamic_Background_Color_Code &&
            formDetails.Embed_Dynamic_Background_Color_Code.includes("#")
          ? formDetails.Embed_Dynamic_Background_Color_Code
          : formDetails.Embed_Dynamic_Background_Color_Code &&
            "#" + formDetails.Embed_Dynamic_Background_Color_Code
      );
      setWidth(formDetails.Embed_Dynamic_Width);
      setHeight(formDetails.Embed_Dynamic_Height);
      setMaxFormHeight(formDetails.Embed_Dynamic_Max_Height);
      setInnerScrollHeight(
        formDetails.Embed_Dynamic_Max_Height > 0 ? true : false
      );
      setDirection(
        isDemoEmbedPage || isPickerForm
          ? getDirection()
          : formDetails.Embed_Dynamic_Culture === "he-IL" ||
            formDetails.Embed_Dynamic_Culture === "ar-SA"
          ? "rtl"
          : "ltr"
      );
      setDisplayFooterLinks(
        typeUser === "premium"
          ? hideFooter
            ? false
            : formDetails.Embed_Dynamic_Display_Footer_Links
          : false
      );

      let needCount = false;
      let websiteLink = window.location.href;
      let jumboMailPages = false; //form-management/create-form/...
      if (document.referrer) {
        websiteLink = document.referrer;
        needCount = true;
      } else {
        let isJumboPage = window.location.href.includes("/page/");
        if (!isJumboPage) {
          jumboMailPages = true;
        }

        needCount = !jumboMailPages;
      }

      if (needCount) {
        if (!counted) {
          updateDynamicStatistic({
            embedDynamicId: formDetails.Embed_Dynamic_Id,
            embedUrl: formDetails.Embed_Dynamic_Url,
          });
          setCounted(true);
        }
      }

      //check if the website not include jumbomail.me get from document.referrer
      if (formDetails.WebsiteLink !== websiteLink && !jumboMailPages) {
        updateJumboFormExternalWebsite({
          embedDynamicId: formDetails.Embed_Dynamic_Id,
          websiteLink: websiteLink,
        });
      }

      setActiveForm(activeForm);
      setAllowUseForm(allowToUseForm);
      setAllowUseFormText(allowToUseFormText);
      setLoading(skipFormParam);
    }
  }, [formDetails, activeFormInJumboFormsPage]);

  useEffect(() => {
    if (formDetails && formDetails.Embed_Dynamic_Custom_Footer_Links) {
      if (!hideFooter && footerDetails) {
        let tempFooter = [];
        footerDetails.EmbedFooterLinksList &&
          footerDetails.EmbedFooterLinksList.map(
            (item, i) =>
              item &&
              tempFooter.push({
                FooterLinkTitle: item.FooterTitle,
                FooterLinkUrl: item.FooterUrl,
              })
          );
        setLinkFooters(tempFooter);
      }
    }
    const origin = `https://${DOMAIN_NAME}`
    const newFooterLinks = [
      {
        FooterLinkTitle: getTextByKey("about-footer"),
        FooterLinkUrl: origin + getPath() + "jumbo-forms",
      },
      {
        FooterLinkTitle: getTextByKey("support-footer"),
        FooterLinkUrl: origin + getPath() + "support/jumbo-embed",
      },
      {
        FooterLinkTitle: getTextByKey("terms-footer"),
        FooterLinkUrl: origin + getPath() + "terms",
      },
    ];
    if (
      displayFooterLinks &&
      formDetails &&
      !formDetails.Embed_Dynamic_Custom_Footer_Links
    ) {
      setLinkFooters(newFooterLinks);
    }
  }, [footerDetails]);

  return <>{children}</>;
};

export default EmbedFormTemplateSettings;
